import React, {Component} from 'react';
import './ProfileSuggestionsBackdrop.css';
import {connect} from 'react-redux';
import actions from './suggestions.actions';
import AboutCard from './AboutCard';
import CommunityAboutCard from './CommunityAboutCard';

const {suggestionsNextStart, suggestionsNextEnd} = actions;

/**
 * Shows a nice big hero-image backdrop for a single provider suggestion at a time. Moves to the next suggestion after a period of time.
 */
class ProfileSuggestionsBackdrop extends Component {
	render() {
		const {current, next, hidden, screenSize, compact} = this.props;

		return current ? (
			<div
				className={`ProfileSuggestionsBackdrop ${
					hidden || compact ? 'ProfileSuggestionsBackdrop-hidden' : ''
				}`}>
				<div
					className={`ProfileSuggestionsBackdrop-currentBackdrop ${next ? 'transitioning' : ''}`}
					style={{
						backgroundImage: `url("/api/image/${current.profile.backgroundImage}")`
					}}
				/>
				<div
					className={`ProfileSuggestionsBackdrop-nextBackdrop ${next ? 'transitioning' : ''}`}
					style={{
						backgroundImage: next && `url("/api/image/${next.profile.backgroundImage}")`
					}}
				/>
				{/* TODO About card for community */}
				{screenSize !== 'mobile' && !compact && current.type !== 'community' && (
					<AboutCard provider={current} />
				)}
				{screenSize !== 'mobile' && !compact && current.type === 'community' && (
					<CommunityAboutCard community={current} />
				)}
			</div>
		) : null;
	}
}

const ConnectedProfileSuggestionsBackdrop = connect(
	state => ({
		current: state.suggestions.items.length
			? state.suggestions.items[state.suggestions.current]
			: null,
		next: state.suggestions.items.length ? state.suggestions.items[state.suggestions.next] : null,
		screenSize: state.ui.screenSize
	}),
	dispatch => ({
		nextSuggestionStart: () => dispatch(suggestionsNextStart()), // Start transition to next
		nextSuggestionEnd: () => dispatch(suggestionsNextEnd())
	})
)(ProfileSuggestionsBackdrop);

export default ConnectedProfileSuggestionsBackdrop;



// WEBPACK FOOTER //
// ./src/profile/ProfileSuggestionsBackdrop.js